import { motion } from "framer-motion";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface NavigationButtonProps {
  to: string;
  index: number;
  children: ReactNode;
}

export function NavigationButton({ to, index, children }: NavigationButtonProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, delay: 1.2 + index * 0.1, ease: "easeOut" }}
      whileHover={{ y: -3 }}
      whileTap={{ scale: 0.98 }}
    >
      <Link
        to={to}
        className="group relative flex h-12 w-full items-center justify-center overflow-hidden rounded bg-black/80 px-4 text-center font-display text-xs font-semibold uppercase leading-none tracking-[0.14em] text-white ring-1 ring-cyan-300/45 transition duration-300 hover:bg-cyan-300/10 hover:text-cyan-50 hover:ring-cyan-200 hover:shadow-[0_0_26px_rgba(34,211,238,0.45)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-cyan-300 sm:h-[68px] sm:px-5 sm:text-sm sm:tracking-[0.2em]"
      >
        <span className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-cyan-200 to-transparent opacity-70" />
        <span className="absolute inset-x-4 bottom-0 h-px bg-gradient-to-r from-transparent via-teal-300 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-90" />
        <span className="absolute -left-10 top-0 h-full w-10 skew-x-[-18deg] bg-white/20 opacity-0 blur-sm transition-all duration-500 group-hover:left-[115%] group-hover:opacity-100" />
        <span className="relative">{children}</span>
      </Link>
    </motion.div>
  );
}
